import { useEffect } from 'react';
import { Text } from 'foundations-components/components/Text';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const warnedTypes = new Set();
export function resetWarnedTypes() {
  warnedTypes.clear();
}
const CustomComponentFallback = ({
  text,
  warnNamespace,
  warnComponentType
}) => {
  useEffect(() => {
    if (warnNamespace && warnComponentType) {
      const key = `${warnNamespace}/${warnComponentType}`;
      if (!warnedTypes.has(key)) {
        warnedTypes.add(key);
        Raven.captureMessage(`[CustomComponent] unregistered: ${warnNamespace}/${warnComponentType}`, {
          level: 'warning',
          tags: {
            namespace: warnNamespace,
            customComponentType: warnComponentType
          }
        });
      }
    }
  }, [warnNamespace, warnComponentType]);
  return /*#__PURE__*/_jsx(Text, {
    color: "text-core-default",
    children: text
  });
};
export default CustomComponentFallback;